export default __webpack_public_path__ + "3a346df3c0b2e4d194e62a12ddf48bcb.svg";